/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {quat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */
module.exports = require('gl-vec4/scale')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/scale.js
// module id = 269
// module chunks = 0